<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $tc("rawmaterials", 2) }}
      </div>
      <router-link class="btn-blue" to="raw-materials"
        >{{ $tc("rawmaterials", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row" style="zoom: 0.9">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="text"
                  v-model="rm_name"
                  name="rawmaterial"
                  id="rawmaterial"
                  v-validate="'required|max:200'"
                  placeholder="."
                />
                <label>{{ $tc("rawmaterials", 2) }}</label>
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('rawmaterial')">{{
                errors.first("rawmaterial")
              }}</span>
            </p>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="text"
                  v-model="alt_rm_name"
                  name="alt_rm_name"
                  id="alt_rm_name"
                  v-validate="'max:200'"
                  placeholder="."
                />
                <label>{{ 'Alternate Name' }}</label>
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('alt_rm_name')">{{
                errors.first("alt_rm_name")
              }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="rmc_label.length > 0 ? 'shift-up' : ''"
                >{{ $tc("rawmaterials", 1) }} {{ $tc("category", 1) }}</label
              >
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :text="rmc_label"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Raw Material"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchRawMaterial()"
                      v-on:keydown="onSearchRawMaterial()"
                      v-on:search="onSearchRawMaterial()"
                      v-model="searchRawMaterial"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(rmc, rmcIndex) in raw_material_categories"
                    :key="rmcIndex"
                    href="#"
                    @click="
                      rmc_id = rmc.rmc_id;
                      rmc_label = rmc.rmc_category;
                      searchRawMaterial = '';
                      onSearchRawMaterial();
                    "
                    >{{ rmc.rmc_category }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <p class="error_message">
                <span v-if="submitted && rmc_label == ''"
                  >Please Select Raw Material Category.</span
                >
              </p>
            </div>
          </div>

          <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input type="text" v-model="rm_code" name="code" id="code" placeholder="." />
                <label>{{ $t('code') }}</label>
              </div>
              <Tooltip :title="$t('rawmaterial_Code')" />
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>-->

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="text"
                  v-model="stock_alert_quantity_threshold"
                  name="quantity"
                  id="quantity"
                  v-validate="'required|numeric|max_value:999999'"
                  placeholder="."
                />
                <label>{{ $t("minimumstocklevel") }}</label>
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('quantity')">{{
                errors.first("quantity")
              }}</span>
            </p>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="uom_id_threshold_label.length > 0 ? 'shift-up' : ''"
                >{{ $tc("unitofmeasurement", 2) }}</label
              >
              <div class="d-flex justify-content-center align-items-center">
                <b-dropdown
                  :text="uom_id_threshold_label"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <div class="px-2 pb-2">
                    <input
                      required
                      autofocus
                      type="search"
                      placeholder="Search Unit"
                      class="form-control form-control-sm"
                      v-on:keyup="onSearchUnit()"
                      v-on:keydown="onSearchUnit()"
                      v-on:search="onSearchUnit()"
                      v-model="searchUnit"
                    />
                  </div>
                  <b-dropdown-item
                    v-for="(city, cityIndex) in units_of_measurements"
                    :key="cityIndex"
                    href="#"
                    @click="
                      uom_id_threshold = city.uom_id;
                      uom_id_threshold_label = city.uom_unit;
                      searchUnit = '';
                      onSearchUnit();
                    "
                    name="uomdropdown"
                    id="uomdropdown"
                    >{{ city.uom_unit }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <p class="error_message">
                <span v-if="submitted && uom_id_threshold_label.length == 0"
                  >Please Select Unit of Measurement.</span
                >
              </p>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  v-model="rm_description"
                  name="rm_description"
                  id="rm_description"
                  v-validate="'max:250'"
                  placeholder="."
                />
                <label>{{ $t("description") }}</label>
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('rm_description')">{{
                errors.first("rm_description")
              }}</span>
            </p>
          </div>

           <template v-if="showErpColumns">
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="report_code"
                    name="report_code"
                    id="report_code"
                    placeholder="."
                    v-validate="'regex:/^[a-zA-Z0-9 ]*$/|max:150'"
                  />
                  <label>{{ "Report Code" }}</label>
                </div>
              </div>
              <p class="error_message">
                <span></span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="gl_account"
                    name="gl_account"
                    id="gl_account"
                    placeholder="."
                   v-validate="'regex:/^[a-zA-Z0-9 ]*$/|max:150'"
                  />
                  <label>{{ "GL Account" }}</label>
                </div>
              </div>
              <p class="error_message">
                <span></span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    v-model="gl_desc"
                    name="gl_desc"
                    id="gl_desc"
                    placeholder="."
                   v-validate="'regex:/^[a-zA-Z0-9 ]*$/|max:150'"
                  />
                  <label>{{ "GL Description" }}</label>
                </div>
              </div>
              <p class="error_message">
                <span></span>
              </p>
            </div>
           </template>

          <div class="col-xl-6 col-lg-8 col-sm-12 align-self-center mb-2">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox"
                  style="padding-bottom: 0px"
                  v-model="is_inventory"
                  unchecked-value="N"
                  value="Y"
                >
                </b-form-checkbox>
                <label class="mb-0" style="white-space: nowrap">{{
                  "Is Inventory"
                }}</label>
              </div>

              <div class="d-flex align-items-center">
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox"
                  style="padding-bottom: 0px"
                  v-model="recco"
                >
                </b-form-checkbox>
                <label class="mb-0" style="white-space: nowrap">{{
                  $t("recco")
                }}</label>
              </div>

              <div class="d-flex align-items-center">
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox"
                  style="padding-bottom: 0px"
                  v-model="is_expiry_available"
                >
                </b-form-checkbox>
                <label class="mb-0" style="white-space: nowrap">{{
                  $t("isExpiryavailable")
                }}</label>
              </div>

              <div class="d-flex align-items-center">
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox"
                  style="padding-bottom: 0px"
                  v-model="rm_is_active"
                >
                </b-form-checkbox>
                <label class="mb-0" style="white-space: nowrap">{{
                  $t("active")
                }}</label>
              </div>
            </div>
          </div>
          
          <div class="col-md-12 text-center mt-4">
            <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit(true)"
              class="btn-blue"
            >
              {{ $t("save") }}
            </button>
            <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit(false)"
              class="btn-blue"
            >
              {{ $t("saveaddmore") }}
            </button>
            <button @click.prevent.stop="onResetForm()" class="btn-black">
              {{ $t("reset") }}
            </button>
            <b-button
              class="btn-outline-grey"
              variant="default"
              to="raw-materials"
              >{{ $t("cancel") }}</b-button
            >
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
export default {
  components: { Multiselect },
  data() {
    return {
      raw_material_categoriesCopy: [],
      searchRawMaterial: "",
      searchUnit: "",
      units_of_measurementsCopy: [],
      btenable: false,
      submitted: false,
      errmsg: "",
      rm_name: "",
      alt_rm_name: "",
      rmc_id: "",
      rmc_label: "",
      rm_code: "",
      rm_rte: false,
      recco: false,
      is_expiry_available: false,
      validStatus: false,
      rm_description: "",
      stock_alert_quantity_threshold: "",
      uom_id_threshold: "",
      rm_is_perishable: false,
      rm_is_active: true,
      selected: null,
      uom_id_threshold_label: "",
      report_code: "",
      erp_item_type: null,
      erp_item_type_selected: "",
      gl_account: "",
      gl_desc: "",
      is_inventory: "Y",
      units_of_measurements: [],
      raw_material_categories: [],
    };
  },
  computed: {
    showErpColumns() {
      return this.$store.getters.SHOW_ERP_GL_FIELDS == 'Y' ? true : false;
    },
  },
  mounted() {
    this.getunitofmeasurements();
    this.getRawMaterialCategoryList();
  },
  methods: {
    onSearchRawMaterial: function () {
      if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
        this.raw_material_categories = this.raw_material_categoriesCopy.filter(
          (x) => {
            if (
              x.rmc_category
                .toLowerCase()
                .includes(this.searchRawMaterial.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.raw_material_categories = this.raw_material_categoriesCopy;
      }
    },
    onSearchUnit: function () {
      if (this.searchUnit && this.searchUnit.length > 0) {
        this.units_of_measurements = this.units_of_measurementsCopy.filter(
          (x) => {
            if (
              x.uom_unit.toLowerCase().includes(this.searchUnit.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.units_of_measurements = this.units_of_measurementsCopy;
      }
    },
    getunitofmeasurements: function () {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.units_of_measurements = data.Records;
            this.units_of_measurementsCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    getRawMaterialCategoryList: function () {
      let payload = {
        tableName: "ms_raw_material_category",
        rmc_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.raw_material_categories = data.Records;
            this.raw_material_categoriesCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    onResetForm: function () {
      (this.rm_name = ""),
      (this.alt_rm_name = ""),
        (this.rm_rte = true),
        (this.recco = true),
        (this.validStatus = false),
        (this.rm_description = ""),
        (this.stock_alert_quantity_threshold = ""),
        (this.uom_id_threshold = ""),
        (this.uom_id_threshold_label = ""),
        (this.rm_is_perishable = false),
        (this.rm_is_active = true),
        (this.rmc_id = ""),
        (this.rmc_label = ""),
        (this.selected = null);
        (this.report_code = "");
        (this.gl_account = "");
        (this.gl_desc = "");
    },
    onFinalSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;
          let payload = {
            rm_name: this.rm_name,
            alt_rm_name: this.alt_rm_name,
            rm_code: this.rm_code,
            rmc_id: this.rmc_id,
            rm_rte: this.rm_rte ? "Y" : "N",
            recco: this.recco ? "Y" : "N",
            is_expiry_available: this.is_expiry_available,
            rm_description: this.rm_description,
            stock_alert_quantity_threshold: this.stock_alert_quantity_threshold,
            uom_id_threshold: this.uom_id_threshold,
            report_code: this.report_code,
            gl_account: this.gl_account,
            gl_desc: this.gl_desc,
            is_inventory: this.is_inventory,
            erp_item_type: this.erp_item_type,
            rm_is_perishable: this.rm_is_perishable ? "Y" : "N",
            rm_is_active: this.rm_is_active ? "Y" : "N",
          };
          PosFnbService.AddRawMaterial(payload)
            .then((response) => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$validator.reset();
                this.onResetForm();
                if (flag) {
                  this.$toasted.show(data.message);
                  this.$router.push({
                    path: "raw-materials",
                  });
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError); //message
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RawMaterialsComponents/addRawMaterial.vue